// extracted by mini-css-extract-plugin
module.exports = {"dragAndDrop":"drag_and_drop_dragAndDrop__2hlep","dragging":"drag_and_drop_dragging__3p_XY"};